export default abstract class ReactSessionKeys {
  static readonly ROLE: string = "role";
  static readonly AUTHKEY: string = "authKey";
  static readonly ISAUTH: string = "isAuth";
  static readonly EMULATE_ENABLED: boolean = false;
  static readonly EMULATE_STORE_ORIGIN = { acls: [], group: null, user: null, role: "", authkey: "" };
  static readonly AUTH_EXPIRE_DATE: string = "authExpireDate";
  static readonly METADATA_FIELDS: string = "metadataFields";
  static readonly APP_DATA: string = "appData";
  static readonly PLATFORM_SETTINGS: string = "platformSettings";
  static readonly CUSTOMER_EXT_ID_NAME: string = "customerNameId";
  static readonly SPOCK_AGENT_TYPE: string = "spockAgentType";
  static readonly CURRENT_AUTH: string = "currentAuth";
  static readonly GROUP_ROLES: string = "groupRoles";
  static readonly SNACKBAR_EVENTS_ENABLED: string = "snackbarEvents";
  static readonly CATCH_PHRASE: string = "catchPhrase";
  static readonly OKTA_CODE_VERIFIER: string = "oktaCodeVerifier";
  static readonly OKTA_PLATFORM_ID: string = "oktaPid";
  static readonly SHARED_ACCOUNTS: string = "sharedAccounts";
  static readonly ACTIVE_FEATURES = "activeFeatures";
  static readonly DRIVE_HEAD_ID = "driveHeadId";
  // Calendar
  static readonly CALENDAR_CUSTOMER = "calendarCustomer";
  static readonly CALENDAR_SERVICE = "calendarService";
  static readonly CALENDAR_TASKNAME = "calendarTaskName";
  static readonly CALENDAR_ASSIGNED = "calendarAssigned";
  static readonly CALENDAR_VIEW = "calendarView";
  static readonly CALENDAR_USERGROUP = "calendarUserGroup";
  static readonly CALENDAR_COLOR = "calendarColor";
  static readonly CALENDAR_ONLYMYTASKS = "calendarOnlyMyTasks";
  static readonly CALENDAR_SHOWCONNECTIONS = "calendarShowConnections";
  static readonly CALENDAR_EXPANDEDRESOURCESNAMES = "calendarExpandedResourcesNames";
  static readonly CALENDAR_SELECTEDDATE = "calendarSelectedDate";
  static readonly CALENDAR_SELECTEDVIEW = "calendarSelectedView";
  static readonly CALENDAR_SELECTEDMODE = "calendarSelectedMode";
  static readonly CLIP_LIST_LAYOUT = "clipListLayout";
  static readonly BROWSER_LAYOUT = "browserLayout";
  static readonly DRAG_ORDER_LISTS = "dragOrderList";
  static readonly DOWNLOADED_FILES_PATH = "downloadedFilesPath";
  static readonly PAGE_FILTERS = "pageFilters";
  static readonly PAGE_CACHE = "pageCache";
  static readonly DRAWER_OPEN = "drawerOpen";
  static readonly DENSITY_PER_PAGE = "densityPerPage";
  static readonly LEFT_PANEL_WIDTH = "leftPanelWidth";
  static readonly RIGHT_PANEL_WIDTH = "rightPanelWidth";
  static readonly LAST_UPDATED_MEDIA_TIMESTAMP = "lastUpdatedMediaTimestamp";
  static readonly ROWS_PER_PAGE = "rowsPerPage";
  static readonly TABLES_LAYOUT = "tableLayout";
}
